import { signIn } from 'next-auth/react';

import { Box, Button } from '@mui/material';

import { getSafeCallbackUrl } from '@/libs/auth/redirect-utils';

const providers = [
  {
    name: 'Google',
    id: 'google',
  },
];

export const AuthProviders = ({ requestedRedirect = null }: { requestedRedirect?: string | null }) => {
  return (
    <>
      {providers &&
        Object.values(providers).map((provider) => {
          return (
            <Box key={provider.name} sx={{ mr: 2 }}>
              <Button
                variant='outlined'
                fullWidth
                onClick={() =>
                  signIn(provider.id, {
                    callbackUrl: getSafeCallbackUrl({
                      requestedRedirect,
                      fallbackUrl: window.location.href,
                      origin: window.location.origin,
                    }),
                  })
                }
              >
                Entrar com {provider.name}
              </Button>
            </Box>
          );
        })}
    </>
  );
};
